export default __webpack_public_path__ + "static/media/@isabelabrag.c2805496.jpg";